import { useEffect } from 'react';

import { useUserContactDetailsWithPrivatePhoneQuery } from '@/graphql/generated';
import { useLoginStates } from '@/hooks';

import { getSavedPhone } from './helpers';

export const useUserContactDetails = (
  updateFieldValue: (value: string, field: 'email' | 'phone' | 'countryCode') => void,
  userId: string | undefined
) => {
  const { isLoggedIn } = useLoginStates();

  const { data } = useUserContactDetailsWithPrivatePhoneQuery({
    skip: !isLoggedIn || !userId,
    variables: { userId: userId ?? '0' },
    errorPolicy: 'all',
  });
  const savedEmail = data?.viewer?.accountSettings?.email?.active;
  const { countryCode, number } =
    getSavedPhone(
      data?.viewer?.accountSettings?.phone?.active,
      data?.profileModules?.xingIdModule?.contactDetails?.private
    ) || {};

  useEffect(() => {
    if (savedEmail) updateFieldValue(savedEmail, 'email');

    if (countryCode) updateFieldValue(countryCode, 'countryCode');

    if (number) updateFieldValue(number, 'phone');
  }, [savedEmail, countryCode, number, updateFieldValue]);
};
